export default function (str, length=255, words=true, ellipsis='...') {

  if (str && str.length < length) {
    return str;
  }

  var subString = str ? str.substr(0, length - 1) : '';
  return (words
    ? subString.substr(0, subString.lastIndexOf(' '))
    : subString) + (subString!=='' ? ' ' + ellipsis : '');
  // ellipsis html: "&hellip;"
}
